import {Przedmioty} from './przedmioty.interface';

export const przedmiotyStanPoczatkowy: Przedmioty = {
  przedmioty: []
}
